<div
  class="box-border p-3 rounded-[8px]"
  *ngIf="order"
  (click)="onTabViewClick()"
  style="border-width: 1px"
  [ngClass]="{
    'border-neutrals-300 bg-neutrals-0': order.isRead,
    'border-neutrals-300 bg-[#E2EAF6]': !order.isRead,
  }"
>
  <div class="grid grid-flow-row gap-[12px] w-full" *ngIf="order">
    <div class="flex flex-col">
      <div class="flex justify-between items-center">
        <div class="grid gap-1 grid-flow-col max-w-[200px] overflow-auto">
          <ng-container
            *ngIf="order.businessLines && order.businessLines.length > 0"
          >
            <unicon-product-option-chip
              [product]="product"
              *ngFor="let product of order.businessLines"
            />
          </ng-container>
          <ng-container
            *ngIf="
              order.businessLineNames && order.businessLineNames.length > 0
            "
          >
            <unicon-product-option-chip
              [product]="{
                businessLineName: product,
                quantity: '',
              }"
              *ngFor="let product of order.businessLineNames"
            />
          </ng-container>

          <ng-container
            *ngIf="
              (order.businessLineNames &&
                order.businessLineNames.length === 0) ||
              (order.businessLine && order.businessLine.length === 0)
            "
          >
            <unicon-product-option-chip
              [product]="{
                businessLineName: 'POR DEFINIR',
                quantity: '',
              }"
            />
          </ng-container>
        </div>

        <div class="grid grid-flow-col items-center gap-[3px]">
          <button
            class="block h-5 w-5 overflow-hidden hover:scale-110"
            (click)="onPin($event, order.orderId)"
            [matTooltip]="order.isPinned ? 'Desanclar' : 'Anclar'"
          >
            <ui-icon
              [attr.name]="order.isPinned ? 'pin-filled' : 'pin'"
              m-size="20"
              size="20"
              [attr.fill]="order.isPinned ? 'neutrals-900' : 'neutrals-600'"
            />
          </button>
        </div>
      </div>

      <div class="flex justify-end" #containerHelper>
        <button
          class="block w-0 h-0 overflow-hidden"
          #pinAlertButton
          (click)="stopPropagation($event)"
          [matMenuTriggerFor]="pinResponseAlert"
        ></button>
        <button
          class="block w-0 h-0 overflow-hidden"
          #frameAlertButton
          (click)="stopPropagation($event)"
          [matMenuTriggerFor]="frameResponseAlert"
        ></button>
        <mat-menu
          #pinResponseAlert="matMenu"
          yPosition="below"
          xPosition="before"
        >
          <div
            [class]="
              'flex gap-2 p-3 box-border items-start bg-warning-100 w-[225px]'
            "
          >
            <ui-icon
              name="warning-filled"
              m-size="20"
              size="20"
              fill="warning-300"
            />
            <ui-paragraph
              type="p12"
              mobile-type="p12"
              text-color="neutrals-900"
              font-weight="semibold"
            >
              {{ error }}
            </ui-paragraph>
          </div>
        </mat-menu>
        <mat-menu
          #frameResponseAlert="matMenu"
          yPosition="below"
          xPosition="before"
        >
          <div
            [class]="
              'flex gap-2 p-3 box-border items-start bg-warning-100 w-[225px]'
            "
          >
            <ui-icon
              name="warning-filled"
              m-size="20"
              size="20"
              fill="warning-300"
            />
            <ui-paragraph
              type="p12"
              mobile-type="p12"
              text-color="neutrals-900"
              font-weight="semibold"
            >
              {{ error }}
            </ui-paragraph>
          </div>
        </mat-menu>
      </div>
    </div>

    <div class="grid grid-flow-col gap-1 items-center justify-between">
      <ng-template #platformIcon>
        <div class="block h-4 w-4 overflow-hidden"></div>
      </ng-template>

      <ui-paragraph
        class="whitespace-nowrap overflow-hidden text-ellipsis"
        type="p14"
        mobile-type="p14"
        text-color="neutrals-900"
        [content]="getPrincipalText(order)"
        font-weight="semibold"
      />
      <div
        class="grid items-center justify-start grid-flow-col gap-2"
        *ngIf="lastSessionTime"
      >
        <ui-icon
          name="hour-glass"
          [attr.fill]="getColorIcon()"
          fill="neutrals-900"
          m-size="18"
          size="18"
        />
        <ui-paragraph
          *ngIf="showElapsedTimeText"
          type="p12"
          mobile-type="p12"
          [attr.text-color]="elapsedTimeText ? 'neutrals-900' : 'critical-300'"
          class="w-[40px]"
        >
          {{ elapsedTime }}
        </ui-paragraph>
      </div>
    </div>

    <div class="grid grid-flow-col gap-1 items-start justify-between">
      <p
        *ngIf="order.lastSendMessage"
        class="line-clamp-2 text-ellipsis overflow-hidden text-xs font-normal text-neutrals-900"
        [innerHTML]="formatText(order.lastSendMessage)"
      ></p>
      <p
        *ngIf="order.message"
        class="line-clamp-2 text-ellipsis overflow-hidden text-xs font-normal text-neutrals-900"
        [innerHTML]="formatText(order.message)"
      ></p>
      <div
        class="h-[18px] min-w-[18px] bg-neutrals-900 rounded-[100%] flex justify-center items-center"
        *ngIf="order.unansweredMessageCount; else platformIcon"
      >
        <ui-paragraph
          type="p10"
          mobile-type="p10"
          text-color="neutrals-0"
          font-weight="semibold"
        >
          {{ order.unansweredMessageCount }}
        </ui-paragraph>
      </div>
    </div>

    <div class="flex justify-between items-center">
      <div
        class="grid grid-flow-col gap-1 items-center justify-start overflow-x-auto max-w-[calc(100%-1.5rem)]"
      >
        <!-- Mostrar cantidad y fecha por BusinessLine -->
        <ng-container *ngFor="let product of order.businessLines">
          <track-lead-card-bottom-chip
            [value]="product.quantity"
            [width]="'75px'"
            [truncate]="true"
            [businessLine]="product.businessLineName"
          ></track-lead-card-bottom-chip>
        </ng-container>
      </div>
      <div
        *ngIf="order.assignedAgent"
        class="flex flex-col justify-center items-center box-border w-5 h-5 rounded-[20px] cursor-default"
        [matTooltip]="
          order.assignedAgent.firstName + ' ' + order.assignedAgent.lastName
        "
        [ngClass]="{
          'bg-[#E2EAF6]': order.isRead,
          'bg-neutrals-0': !order.isRead,
        }"
      >
        <ui-paragraph
          type="p8"
          mobile-type="p8"
          font-weight="bold"
          text-color="neutrals-900"
        >
          {{
            getInitials(
              order.assignedAgent.firstName + ' ' + order.assignedAgent.lastName
            )
          }}
        </ui-paragraph>
      </div>
    </div>
  </div>
</div>
